import React, { useEffect } from 'react';
import { Form, Input, Button, Row, Col, Spin } from 'antd';
import { ReactSVG } from 'react-svg';

const RoutePlansFilter = ({ isFetching, query, onSubmit }) => {
  const [form] = Form.useForm();

  const nameField = 'name';
  const nameValue = query[nameField];

  useEffect(() => {
    form.setFieldsValue(initialValues());
  }, [query]);

  const initialValues = () => {
    const values = {};
    values[nameField] = nameValue;
    return values;
  };

  const handleSubmit = (values) => {
    const params = {};
    params[nameField] = values[nameField] || undefined;
    onSubmit({ ...query, ...params, current: 1 }, true);
  };

  const handleResetButton = () => {
    onSubmit({}, true);
    form.resetFields();
  };

  return (
    <Spin spinning={isFetching}>
      <div className="CommonFilter RoutePlansFilter">
        <Form
          form={form}
          onFinish={handleSubmit}
          initialValues={initialValues()}
          className="FilterForm RoutePlansFilterForm"
          layout="vertical"
        >
          <div className="FilterFormHeader">
            <h4>Filter</h4>
            <div className="actions">
              <Button size="small" type="text" onClick={handleResetButton}>
                Clear
                <ReactSVG className="icon" src="/icons/clear_all.svg" />
              </Button>
              <Button className="apply" size="small" type="link" htmlType="submit">
                Apply
                <ReactSVG className="icon" src="/icons/done.svg" />
              </Button>
            </div>
          </div>
          <div className="FilterFormContent">
            <Row gutter={15}>
              <Col xs={{ span: 24 }} md={{ span: 6 }}>
                <Form.Item label="Name" name={nameField}>
                  <Input placeholder="Name" />
                </Form.Item>
              </Col>
            </Row>
          </div>
        </Form>
      </div>
    </Spin>
  );
};

export default RoutePlansFilter;
